module.exports = __webpack_public_path__ + "static/media/campanha_natal_g.c86211d6.gif";